var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundCheckCircle24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 109 9 9 9 0 00-9-9zM6.561 12.861L3.33 9.63A.9.9 0 014.6 8.361l2.6 2.592 6.192-6.192a.9.9 0 011.269 1.269L7.83 12.861a.9.9 0 01-1.269 0z",
    fill: "#66cc80"
  })));
}
export default __webpack_public_path__ + "assets/static/media/round-check_circle-24px.0da0d924.svg";
export { SvgRoundCheckCircle24Px as ReactComponent };